var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "py-16 bg-gray-50 overflow-hidden lg:py-24" }, [
      _c(
        "div",
        {
          staticClass:
            "relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl"
        },
        [
          _c(
            "svg",
            {
              staticClass:
                "hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4",
              attrs: {
                width: "404",
                height: "784",
                fill: "none",
                viewBox: "0 0 404 784",
                "aria-hidden": "true"
              }
            },
            [
              _c("defs", [
                _c(
                  "pattern",
                  {
                    attrs: {
                      id: "b1e6e422-73f8-40a6-b5d9-c8586e37e0e7",
                      x: "0",
                      y: "0",
                      width: "20",
                      height: "20",
                      patternUnits: "userSpaceOnUse"
                    }
                  },
                  [
                    _c("rect", {
                      staticClass: "text-gray-200",
                      attrs: {
                        x: "0",
                        y: "0",
                        width: "4",
                        height: "4",
                        fill: "currentColor"
                      }
                    })
                  ]
                )
              ]),
              _c("rect", {
                attrs: {
                  width: "404",
                  height: "784",
                  fill: "url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
                }
              })
            ]
          ),
          _vm._m(0),
          _c(
            "div",
            {
              staticClass:
                "relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center"
            },
            [
              _c("div", { staticClass: "relative" }, [
                _c(
                  "h3",
                  {
                    staticClass:
                      "text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl"
                  },
                  [_vm._v(" How It works ")]
                ),
                _c("p", { staticClass: "mt-3 text-lg text-gray-500" }, [
                  _vm._v(
                    " Our App will help you to add a widget in your store, that will offer discount code for following your brand on Instagram. "
                  )
                ]),
                _c("dl", { staticClass: "mt-10 space-y-10" }, [
                  _c("div", { staticClass: "relative" }, [
                    _c("dt", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white"
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "h-6 w-6",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                "stroke-width": "2",
                                stroke: "currentColor",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  d:
                                    "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass:
                            "ml-16 text-lg leading-6 font-medium text-gray-900"
                        },
                        [_vm._v(" Easy Setup ")]
                      )
                    ]),
                    _c(
                      "dd",
                      { staticClass: "mt-2 ml-16 text-base text-gray-500" },
                      [
                        _vm._v(
                          " With a single click, you will start increasing your followers. No Coding knowlodge required! "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "relative" }, [
                    _c("dt", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white"
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "h-6 w-6",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                "stroke-width": "2",
                                stroke: "currentColor",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  d:
                                    "M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass:
                            "ml-16 text-lg leading-6 font-medium text-gray-900"
                        },
                        [_vm._v(" More followers. more sales ")]
                      )
                    ]),
                    _c(
                      "dd",
                      { staticClass: "mt-2 ml-16 text-base text-gray-500" },
                      [
                        _vm._v(
                          " With more followers you will be able to keep sharing more information about your brand to them thereby increasing the sales. "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "relative" }, [
                    _c("dt", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white"
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "h-6 w-6",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                "stroke-width": "2",
                                stroke: "currentColor",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  d: "M13 10V3L4 14h7v7l9-11h-7z"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass:
                            "ml-16 text-lg leading-6 font-medium text-gray-900"
                        },
                        [_vm._v(" Fits with your theme ")]
                      )
                    ]),
                    _c(
                      "dd",
                      { staticClass: "mt-2 ml-16 text-base text-gray-500" },
                      [
                        _vm._v(
                          " The popup fits to your brand and theme. It's compatible by default, but you can customize the way you want. "
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _c(
                "div",
                {
                  staticClass: "mt-10 -mx-4 relative lg:mt-0",
                  attrs: { "aria-hidden": "true" }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden",
                      attrs: {
                        width: "784",
                        height: "404",
                        fill: "none",
                        viewBox: "0 0 784 404"
                      }
                    },
                    [
                      _c("defs", [
                        _c(
                          "pattern",
                          {
                            attrs: {
                              id: "ca9667ae-9f92-4be7-abcb-9e3d727f2941",
                              x: "0",
                              y: "0",
                              width: "20",
                              height: "20",
                              patternUnits: "userSpaceOnUse"
                            }
                          },
                          [
                            _c("rect", {
                              staticClass: "text-gray-200",
                              attrs: {
                                x: "0",
                                y: "0",
                                width: "4",
                                height: "4",
                                fill: "currentColor"
                              }
                            })
                          ]
                        )
                      ]),
                      _c("rect", {
                        attrs: {
                          width: "784",
                          height: "404",
                          fill: "url(#ca9667ae-9f92-4be7-abcb-9e3d727f2941)"
                        }
                      })
                    ]
                  ),
                  _c("img", {
                    staticClass: "relative mx-auto",
                    attrs: {
                      width: "490",
                      src: require("../assets/instagram/popup.png"),
                      alt: ""
                    }
                  })
                ]
              )
            ]
          ),
          _c(
            "svg",
            {
              staticClass:
                "hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12",
              attrs: {
                width: "404",
                height: "784",
                fill: "none",
                viewBox: "0 0 404 784",
                "aria-hidden": "true"
              }
            },
            [
              _c("defs", [
                _c(
                  "pattern",
                  {
                    attrs: {
                      id: "64e643ad-2176-4f86-b3d7-f2c5da3b6a6d",
                      x: "0",
                      y: "0",
                      width: "20",
                      height: "20",
                      patternUnits: "userSpaceOnUse"
                    }
                  },
                  [
                    _c("rect", {
                      staticClass: "text-gray-200",
                      attrs: {
                        x: "0",
                        y: "0",
                        width: "4",
                        height: "4",
                        fill: "currentColor"
                      }
                    })
                  ]
                )
              ]),
              _c("rect", {
                attrs: {
                  width: "404",
                  height: "784",
                  fill: "url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
                }
              })
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "relative" }, [
      _c(
        "h2",
        {
          staticClass:
            "text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl"
        },
        [_vm._v(" Grow your Instagram Followers ")]
      ),
      _c(
        "p",
        {
          staticClass:
            "mt-4 max-w-3xl mx-auto text-center text-xl text-gray-500"
        },
        [
          _vm._v(
            " Convert your website visitors to Instagram followers automatically. "
          )
        ]
      ),
      _c("div", { staticClass: "flex justify-center mt-10" }, [
        _c(
          "a",
          {
            staticClass:
              "inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
            attrs: {
              href:
                "https://apps.shopify.com/carthike-insta-boost?surface_detail=carthike_app_referral",
              target: "_blank",
              type: "button"
            }
          },
          [_vm._v(" Try now for free ")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }